import { getFullUrl } from 'hubspot-url-utils';
const hubspotApi = getFullUrl('app');
export default {
  HUBSPOT_API: hubspotApi,
  HUBSPOT_LOGIN: `${hubspotApi}/login`,
  SIDEKICK_API: getFullUrl('api', {
    domainOverride: 'getsidekick'
  }),
  SIDEKICK_GAE_API: getFullUrl('app', {
    domainOverride: 'getsidekick'
  })
};